import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=673916b8&"
import script from "./EditDialog.js?vue&type=script&lang=js&"
export * from "./EditDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VEditDialog})
